import React from 'react';
import PropTypes from 'prop-types';

import './FeatureBox.scss';

const FeatureBox = ({ icon, description, title }) => {
  return (
    <div className="feature-box">
      <div className="feature-box__icon">{icon}</div>
      {title && <h3 className="feature-box__title">{title}</h3>}
      <div className="feature-box__description">{description}</div>
    </div>
  );
};

FeatureBox.propTypes = {
  icon: PropTypes.node.isRequired,
  description: PropTypes.string.isRequired,
  title: PropTypes.string
};

FeatureBox.defaultProps = {
  title: ''
};

export default FeatureBox;
